/**
 * Environment configuration
 * Centralizes all environment variables with type safety
 */

export const env = {
  // Supabase
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
  
  // App
  appName: import.meta.env.VITE_APP_NAME || 'Decixa',
  appUrl: import.meta.env.VITE_APP_URL || 'http://localhost:3000',
  
  // Feature flags
  enableAIAdvisor: import.meta.env.VITE_ENABLE_AI_ADVISOR === 'true',
  enableGroups: import.meta.env.VITE_ENABLE_GROUPS === 'true',
  enableReputation: import.meta.env.VITE_ENABLE_REPUTATION === 'true',
  
  // Environment
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
